@import '../styles/palette.scss';

$rowBorder: 1px solid;

.avdelinger {
  font-size: 13pt;

  p {
    margin-top: 12px;
  }

  .table {
    line-height: 50px;
  }

  .headerRow {
    font-weight: 600;
  }

  .topRow {
    border-bottom: $rowBorder;
    border-top: $rowBorder;
    cursor: pointer;
    margin-top: -1px; // Avoid double border
    color: _palette(text);

    &.organizationTop {
      background-color: _palette(table-row-sky) !important;
      font-size: 18px;
    }

    &:not(.organizationTop) {
      background-color: _palette(table-row-shade) !important;
    }

    .name {
      font-weight: 600;

      a {
        &:hover {
          text-decoration: none;
        }
      }
    }
  }

  .row {
    position: relative;

    .iconAndName {
      display: flex;

      .iconWrapper {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        margin-right: 0.25em;
        margin-left: calc(-24px - 0.25em);

        .endNodeWrapper {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 24px;
          height: 24px;
        }
      }

      .name {
        align-items: center;
        display: flex;

        svg {
          margin-right: 0.33em;
        }

        a {
          color: black;

          &:hover {
            text-decoration: none;
          }
        }
      }
    }
  }

  .row:nth-child(2n) {
    background-color: _palette(bg-primary);
  }

  .row:nth-child(2n + 1) {
    background-color: white;
  }
}
